export default {
    // search limit popup
    tooManySearchRequests: "搜索请求太多",
    reachedTheLimitForRealTime: "您已达到“实时”搜索的限制。",
    useTheRecentModeToExploreResults: "与此同时，您可以使用“最近”模式仅基于我们数据库中已有的数据来探索结果",
    btnTryLaterAgain: "稍后再试",
    btnUseRecentMode: "使用最近模式",

    // Create New Sequence
    createNewSequence: '创建新流程',
    sequenceName: "流程名称",
    enterSequenceName: "请输入流程名称",

    // Not enough credits
    uDontHaveEnoughCredits: "您没有足够的信用点",
    addMinimumCredits: "是否要添加 {count} 信用点（最低充值金额）以继续搜索？",
    btnAddCredits: "增加信用点",

    // Payment Method Required
    paymentMethodRequired: "需添加付款方式",
    dontHaveAPaymentMethodLinkedToYourAccount: '看起来您的帐户没有链接付款方式。',
    pleaseAddYourPaymentMethodToContinue: "请添加您的付款方式以继续。",
    btnAddNow: '立即添加',

    // Credit Running Low!
    creditRunningLow: "信用点余额低！",
    yourCreditIsRunningLow: "您的信用额度不足，我们无法处理自动充值。",
    pleaseManuallyTopupYourCredit: "请手动充值您的信用额度，以避免服务中断。",
    btnTopup: "现在充值",

    // You've Reached Your Limit
    uHaveReachedYourLimit: "您的搜索已达到限制数量",
    subscriptionTiers: "订阅级别",
    switchPlansSeamlessly: "无缝切换计划——您剩余的积分将作为充值积分转移，以备将来使用。",
    tabMonthly: "按月",
    tabAnnual: "按年",
    tableFieldCredits: "信用点",
    tableFieldTopupCredit: '信用点充值',
    tableFieldPageLimit: "页面上限",
    tableFieldExportLimit: "导出上限",
    tableFieldAPI: "API",
    tableFieldRolePermission: '自定义角色权限',
    tableFieldTeamManagement: "团队管理",
    tableFieldPrice: "价格-每位用户，每月计费",
    tableFieldFeatures: "特色",
    titleTiers: "等级",
    btnChangePlan: '选择计划',
    btnCurrentPlan: '当前计划',

    // Upgrade to Unlock This Feature
    upgradeToUnlockThisFeature: "升级以解锁此功能",
    thisFeatureIsAvailableOnlyForUpgradedPlanUsers: '此功能仅适用于升级的计划用户。',
    upgradeYourPlanToEnjoyEnhancedFunctionality: '升级您的计划，享受增强的功能，并解锁更多根据您的需求量身定制的可能性。',
    btnBack: '返回',
    btnUpgradeNow: '现在升级'

};